import { GenericRemoteActionBuilder } from '../remote-action-builder';
import { Injectable, ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { RemoteAction } from '../../remote-action';
import { TimeCorrectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/time-correction-remote-action-builder-ui-step/time-correction-remote-action-builder-ui-step';
import { TimeCorrectionComponent } from 'src/app/_components/remote-action-step/time-correction/time-correction.component';

import { LocationService } from 'src/app/_services/location/location.service';
import { EmployeeService } from 'src/app/_services/employee/logic/employee.service';
import { ServicejobSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/servicejob-select-remote-action-builder-ui-step/servicejob-select-remote-action-builder-ui-step';
import { PlaceTypeRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/placetype-remote-action-builder-service-step/placetype-remote-action-builder-service-step';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServicejobSelectRaStepComponent } from 'src/app/_components/remote-action-step/servicejob-select-ra-step/servicejob-select-ra-step.component';
import { ServicejobRemoteActionType } from './servicejob-remote-action-type';
import { ServicejobIdRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/servicejob-id-remote-action-builder-service-step/servicejob-id-remote-action-builder-service-step';
import { ServicejobsService } from 'src/app/_services/servicejobs/logic/servicejobs.service';
import { ActivityTypeSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/activity-type-select-remote-action-builder-ui-step/activity-type-select-remote-action-builder-ui-step';
import { KeywordSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/keyword-select-remote-action-builder-ui-step/keyword-select-remote-action-builder-ui-step';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { ExecutedWorkRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/executed-work-remote-action-builder-ui-step/executed-work-remote-action-builder-ui-step';
import { TeamRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/team-remote-action-builder-service-step/team-remote-action-builder-service-step';
import { OtherPlaceTextRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/other-place-text-remote-action-builder-ui-step/other-place-text-remote-action-builder-ui-step';
import { JobSectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/jobsection-select-remote-action-builder-ui-step/jobsection-select-remote-action-builder-ui-step';
import { JobSectionsService } from 'src/app/_services/job-section/logic/job-section.service';
import { JobSectionSelectRaStepComponent } from 'src/app/_components/remote-action-step/jobsection-select-ra-step/jobsection-select-ra-step.component';
import { LBSUtils } from 'src/app/_util/lbs-utils';

@Injectable()
export class ServicejobRemoteActionBuilder extends GenericRemoteActionBuilder {
  constructor(
    private type: ServicejobRemoteActionType,
    appService: AppService,
    credentialsService: CredentialsService,
    private servicejobService: ServicejobsService,
    locationService: LocationService,
    employeeService: EmployeeService,
    jobSectionsService: JobSectionsService,
    private clientStateService: ClientStateService,
    private appParameterService: AppParameterService,
    private logger?: LoggingService
  ) {
    super(
      type.pageTitle,
      appService,
      credentialsService,
      {
        endpoint: type.endpoint,
        data: {},
        cachable: true,
        fifo: true,
        authenticationRequired: true,
        shortLabel: type.raShortLabel,
        shortLabelTranslate: true,
      },
      // In case we end the service job there is no selection of a new servicejob
      type === ServicejobRemoteActionType.END_OF_SERVICEJOB
        ? []
            .concat(
              appParameterService.appParameters$
                .getValue()
                .getBooleanParameter('imsmc.job.reportexecutedwork', true)
                ? [new ExecutedWorkRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()[
                'imsmc.job.reportactivitytype'
              ]
                ? [new ActivityTypeSelectRemoteActionBuilderUIStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()['imsmc.use.keyword']
                ? [new KeywordSelectRemoteActionBuilderUIStep(logger)]
                : []
            )
            .concat([new TimeCorrectionRemoteActionBuilderUiStep(logger)])
        : type === ServicejobRemoteActionType.CHANGE_OF_SERVICEJOB
        ? []
            .concat(
              appParameterService.appParameters$
                .getValue()
                .getBooleanParameter('imsmc.job.reportexecutedwork', true)
                ? [new ExecutedWorkRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()[
                'imsmc.job.reportactivitytype'
              ]
                ? [new ActivityTypeSelectRemoteActionBuilderUIStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()['imsmc.use.keyword']
                ? [new KeywordSelectRemoteActionBuilderUIStep(logger)]
                : []
            )
            .concat([
              new ServicejobSelectRemoteActionBuilderUIStep(logger),
              new OtherPlaceTextRemoteActionBuilderUiStep(logger),
              new JobSectionRemoteActionBuilderUiStep(
                jobSectionsService,
                logger
              ),
              new JobSectionRemoteActionBuilderUiStep(
                jobSectionsService,
                logger
              ),
              new JobSectionRemoteActionBuilderUiStep(
                jobSectionsService,
                logger
              ),
              new JobSectionRemoteActionBuilderUiStep(
                jobSectionsService,
                logger
              ),
              new TimeCorrectionRemoteActionBuilderUiStep(logger),
            ])
        : [
            new ServicejobSelectRemoteActionBuilderUIStep(logger),
            new OtherPlaceTextRemoteActionBuilderUiStep(logger),
            new JobSectionRemoteActionBuilderUiStep(jobSectionsService, logger),
            new JobSectionRemoteActionBuilderUiStep(jobSectionsService, logger),
            new JobSectionRemoteActionBuilderUiStep(jobSectionsService, logger),
            new JobSectionRemoteActionBuilderUiStep(jobSectionsService, logger),
            new TimeCorrectionRemoteActionBuilderUiStep(logger),
          ],
      // In case we end or change the service job we need to transmit the current servicejob
      type === ServicejobRemoteActionType.START_OF_SERVICEJOB
        ? [
            new PlaceTypeRemoteActionBuilderServiceStep(
              clientStateService,
              logger
            ),
            new TeamRemoteActionBuilderServiceStep(
              employeeService,
              clientStateService,
              logger
            ),
            new GpsRemoteActionBuilderServiceStep(locationService, logger),
          ]
        : [
            new ServicejobIdRemoteActionBuilderServiceStep(
              clientStateService,
              servicejobService,
              logger
            ),
            new PlaceTypeRemoteActionBuilderServiceStep(
              clientStateService,
              logger
            ),
            new TeamRemoteActionBuilderServiceStep(
              employeeService,
              clientStateService,
              logger
            ),
            new GpsRemoteActionBuilderServiceStep(locationService, logger),
          ],
      async (data: any) => {
        logger.log(
          this.constructor.name,
          ' Executing post generate function',
          data
        );

        if (data['pt_real']) {
          await this.clientStateService.updatePlace(
            data['pt_real'],
            data['destinationInfo']
          );
        }
        if (data['next_sjobid']) {
          // JB20191022: Servicejob was transmitted. Set this service job as current servicejob
          const checkedSJob = this.servicejobService.getServiceJobById(
            data['next_sjobid']
          );
          if (checkedSJob) {
            await this.clientStateService.setServicejobId(checkedSJob.id);
          } else {
            this.logger.log(
              this.constructor.name,
              'provided sjob id is not available, try finding sjob by secondarykey',
              data['next_sjob_secondarykey']
            );

            if (data['next_sjob_secondarykey']) {
              const foundSjobsBySecondaryKey =
                this.servicejobService.servicejobs$.getValue().filter((val) => {
                  return (
                    data['next_sjob_secondarykey'] ===
                      val.appaccountingnumber ||
                    data['next_sjob_secondarykey'] === val.accountingnumber
                  );
                });

              if (
                foundSjobsBySecondaryKey &&
                foundSjobsBySecondaryKey.length > 0
              ) {
                if (foundSjobsBySecondaryKey.length === 1) {
                  await this.clientStateService.setServicejobId(
                    foundSjobsBySecondaryKey[0].id
                  );
                } else {
                  this.logger.warn(
                    this.constructor.name,
                    'Found multiple sjobs for skey take first one'
                  );
                  await this.clientStateService.setServicejobId(
                    foundSjobsBySecondaryKey[0].id
                  );
                }
              } else {
                this.logger.error(
                  this.constructor.name,
                  'Warning no secondary key sjob found'
                );
              }
            }
          }
          await this.clientStateService.startServicejob();
        } else if (data['next_branchid']) {
          await this.clientStateService.setBranchId(data['next_branchid']);
          const finish = data['sjobfinish'] ? true : false;
          await this.clientStateService.stopServicejob(finish, false);
        } else {
          const finish = data['sjobfinish'] ? true : false;
          await this.clientStateService.stopServicejob(finish, false);
        }
        if (data['curjsid']) {
          logger.log(
            this.constructor.name,
            'found jobsection id in remote action update clientstate',
            data['curjsid']
          );
          await this.clientStateService.setJobSectionId(data['curjsid']);
        }
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    return super.generateRemoteAction(dataValues);
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);

    if (componentRef.instance instanceof TimeCorrectionComponent) {
      this.logger.log(
        this.constructor.name,
        'Generate Component of Type TimeCorrectionComponent report servicejob'
      );
      (<TimeCorrectionComponent>componentRef.instance).setDescription(
        this.type.descriptionKey
      );
      (<TimeCorrectionComponent>componentRef.instance).setTitle(
        this.type.titleKey
      );

      const appParams = this.appParameterService.appParameters$.getValue();
      if (appParams != undefined) {
        switch (this.type) {
          case ServicejobRemoteActionType.START_OF_SERVICEJOB:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.sosj',
                false
              );
            break;
          case ServicejobRemoteActionType.END_OF_SERVICEJOB:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.eosj',
                false
              );
            break;
          case ServicejobRemoteActionType.CHANGE_OF_SERVICEJOB:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.cosj',
                false
              );
            break;
        }
      }
    }
    if (componentRef.instance instanceof ServicejobSelectRaStepComponent) {
      this.logger.log(
        this.constructor.name,
        'Generate Component of Type ServicejobSelectRaStepComponent report servicejob'
      );
      (<ServicejobSelectRaStepComponent>(
        componentRef.instance
      )).hideFinishedServicejobs();
    }

    // Configure specific Components
    if (componentRef.instance instanceof JobSectionSelectRaStepComponent) {
      const currentData = super.getRemoteActionData();
      const appParams = this.appParameterService.appParameters$.getValue();
      if (
        (LBSUtils.convertStringBool(
          appParams[
            'imsmc.remoteaction-step.jobsection-select.allow-branch-sections.sosj'
          ],
          false
        ) &&
          this.type === ServicejobRemoteActionType.START_OF_SERVICEJOB) ||
        (LBSUtils.convertStringBool(
          appParams[
            'imsmc.remoteaction-step.jobsection-select.allow-branch-sections.cosj'
          ],
          false
        ) &&
          this.type === ServicejobRemoteActionType.CHANGE_OF_SERVICEJOB)
      ) {
        (<JobSectionSelectRaStepComponent>(
          componentRef.instance
        )).allowBranchSelection();
      }

      if (currentData['curjsid']) {
        (<JobSectionSelectRaStepComponent>(
          componentRef.instance
        )).parentJobSectionId = currentData['curjsid'];
      } else if (currentData['next_sjobid']) {
        (<JobSectionSelectRaStepComponent>componentRef.instance).sjobId =
          currentData['next_sjobid'];
      }
    }

    return componentRef;
  }
}
